module.exports = __webpack_public_path__ + "static/media/QRCode.7100a5e4.png";